<!--
   Actions menu for one table row: Edit, Soft Delete, Restore, Delete Permanently, View.
   Use:
     <RowActions
        :record="record"
        :modal-id="'deleteCrudModal' + record.id"
        :can-edit="$hasPermission('...')"
        :can-soft-delete="$hasPermission('...')"
        :can-restore="$hasPermission('...')"
        :can-delete-permanently="$hasPermission('...')"
        @edit="editRecord"
        @delete-type="setDeleteType"
     />
   - Edit and Soft Delete show only on live rows; Restore and Delete Permanently only on deleted rows.
   - Delete buttons open the DeleteModal with the same modal-id.
   - Anything put between <RowActions> and </RowActions> is added to the menu, just above View.
-->
<template>
   <div class="d-flex justify-content-end align-items-center w-100 flex-wrap">
      <div class="btn-group">
         <!-- Computers (768px+): "Actions ▾" as before. Phones: ⋮ only (no ▾, see app-table.css) -->
         <button type="button" class="btn btn-secondary dropdown-toggle row-actions-btn" data-bs-toggle="dropdown" aria-label="Actions">
            <i class="fa fa-ellipsis-v d-md-none"></i><span class="d-none d-md-inline">Actions</span>
         </button>
         <ul class="dropdown-menu dropdown-menu-end actions-menu">
            <li>
               <button
                  v-if="canEdit && !isDeleted"
                  type="button"
                  class="btn btn-default"
                  @click="$closeAllDetails(); $emit('edit', record)"
                  title="Edit (Alt+M)"
                  data-bs-toggle="modal"
                  data-bs-target="#recordFormModal"
               >
                  <i class="fa fa-edit me-1 text-primary"></i> Edit
               </button>
            </li>
            <li>
               <button
                  v-if="canSoftDelete && !isDeleted"
                  type="button"
                  class="btn btn-default"
                  data-bs-toggle="modal"
                  :data-bs-target="'#' + modalId"
                  @click="$emit('delete-type', 'soft')"
               >
                  <i class="fa fa-trash me-1 text-danger"></i> Soft Delete
               </button>
            </li>
            <li>
               <button
                  v-if="canRestore && isDeleted"
                  type="button"
                  class="btn btn-default"
                  data-bs-toggle="modal"
                  :data-bs-target="'#' + modalId"
                  @click="$emit('delete-type', 'restore')"
               >
                  <i class="fa fa-undo me-1 text-success"></i> Restore
               </button>
            </li>
            <li>
               <button
                  v-if="canDeletePermanently && isDeleted"
                  type="button"
                  class="btn btn-default"
                  data-bs-toggle="modal"
                  :data-bs-target="'#' + modalId"
                  @click="$emit('delete-type', 'permanent')"
               >
                  <i class="fa fa-times me-1 text-danger"></i> Delete Permanently
               </button>
            </li>
            <slot />
            <li>
               <button type="button" class="dropdown-item" @click="$toggleRecordDetails(record.id)">
                  <i class="fa fa-eye me-1 text-info"></i> View
               </button>
            </li>
         </ul>
      </div>
   </div>
</template>

<script>
export default {
   name: "RowActions",
   props: {
      // The table row (needs id and is_deleted)
      record: { type: Object, required: true },
      // Id of this row's DeleteModal, without the "#"
      modalId: { type: String, required: true },
      canEdit: { type: Boolean, default: true },
      canSoftDelete: { type: Boolean, default: false },
      canRestore: { type: Boolean, default: false },
      canDeletePermanently: { type: Boolean, default: false },
   },
   emits: ["edit", "delete-type"],
   computed: {
      // is_deleted comes from the API as 0/1 or "0"/"1"
      isDeleted() {
         return Number(this.record.is_deleted) === 1;
      },
   },
};
</script>
